export enum EFinancasRoutes {
  credenciamento = "credenciamento",
  treinamentos = "treinamentos",
  antecipa = "home",
  antecipaContratacao = "antecipaContratacao",
  RegraDeRateio = "RegraDeRateio"
}
